import React, { useState } from "react";
import ModalInDrawer from "../ui/ModalInDrawer";
import { FaCheckCircle, FaUpload } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";
const SubirArchivoPagoCotizacionDialog = ({
  title,
  open,
  onClose,
  setRowValues,
  data,
  setUpdatedDataText
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState("");

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file.size > 5 * 1000000) {
      window.alert("Archivo superior a 5mb");
      return;
    }
    setSelectedFile(file);
    if (file) {
      // Update state with the selected file
      setSelectedFile(file);
      setSelectedFileType(file.type);
    }
  };

  const uploadImage = async () => {
    try {
      // First request
      const formData = new FormData();
      formData.append("file", selectedFile);

      const dataImage = await axios.post(
        `${BACKEND}/api/pagosCotizacionesImagenes`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Second request
      const responseUpdatePagoCotizacion = await axios.put(
        `${BACKEND}/api/pagosCotizaciones/${data.id}`, { 
          imagen: dataImage.data.doc.id,
          fechaPago: new Date().toISOString()
        }
      );

      // Update state and close modal when the second request is successful
      setRowValues((prev) => ({ ...prev, imagen: dataImage.data.doc, fechaPago: 
        {
          startDate: new Date().toISOString().split("T")[0],
          endDate: new Date().toISOString().split("T")[0]
        } }));
      onClose();
      setSelectedFile(null)
      setSelectedFileType("")
      setUpdatedDataText((prev) => prev + `Imagen del pago actualizada.\n`)
      toast.success("Guardado exitosamente", {
        style: { zIndex: 9999 },
        position: "top-center",
      });
    } catch (error) {
      // Handle errors from either the first or second request
      console.error("Error in uploadImage:", error);
      toast.error("Error al subir esta imagen", {
        style: { zIndex: 9999 },
        position: "top-center",
      });
    }
  };
  return (
    <ModalInDrawer activeModal={open} onClose={onClose} title={title}>
      <div className="flex flex-col gap-4 items-center justify-center w-full">
      <span className="block text-center text-sm text-gray-400">
        Si necesitas subir más de una imagen o PDF, une los archivos en estas páginas:
        <br />
        PDF: {" "}
        <a 
          href="https://www.ilovepdf.com/es" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-blue-500 hover:underline"
        >
          https://www.ilovepdf.com/es
        </a>
        <br />
        Imágenes: {" "} 
        <a 
          href="https://pinetools.com/es/combinar-imagenes" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-blue-500 hover:underline"
        >
          https://pinetools.com/es/combinar-imagenes
        </a>
      </span>

        {selectedFile && selectedFileType.startsWith("image/") && (
          <div>
            <img
              src={URL.createObjectURL(selectedFile)} // Use createObjectURL for local files
              style={{ maxWidth: "100%", maxHeight: "300px" }}
              className=" rounded-md"
            />
          </div>
        )}
        {selectedFile && (
          <div className=" w-full flex justify-center items-center gap-4">
            <div className=" flex justify-center gap-2 items-center bg-green-50 text-green-700 rounded-md p-2">
              {selectedFile.name}
              <FaCheckCircle />
            </div>
            <button
              onClick={() => {
                setSelectedFileType("");
                setSelectedFile(null);
              }}
              className="p-2 bg-red-50 rounded-md flex justify-center text-red-700 hover:text-red-800"
            >
              <MdClose />
            </button>
          </div>
        )}
        {!selectedFile && (
          <label
            htmlFor="dropzone-file"
            onDrop={handleFileUpload}
            className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
          >
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              <svg
                className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 16"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                />
              </svg>
              <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                <span className="font-semibold">
                  Click para subir tu archivo
                </span>
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                SVG, PNG, JPG , WEBP, PDF, DOC, DOCX, XLS (MAX. 5MB)
              </p>
            </div>
            <input
              onChange={handleFileUpload}
              id="dropzone-file"
              accept=".pdf, .doc, .docx, .xls, image/*"
              type="file"
              className="hidden"
            />
          </label>
        )}
      </div>

      {selectedFile && (
        <div className=" flex justify-center items-center  my-6">
          <button
            onClick={uploadImage}
            className="  flex justify-center items-center gap-4 max-w-xs w-full p-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white"
            type="button"
          >
            Subir <FaUpload />
          </button>
        </div>
      )}
    </ModalInDrawer>
  );
};

export default SubirArchivoPagoCotizacionDialog;
